// Checks for non-word chars, excluding letters, combining marks, and digits
export const getAreaRegex = (includeHyphen?: boolean) =>
  new RegExp('[^\\p{Letter}\\p{Mark}0-9 ' + (includeHyphen ? '-' : '') + ']+', 'gu');
